import _ from 'lodash';
import { denormalize } from 'normalizr';
import * as Schema from '../schema';

export const STATE_KEY = 'collections';

export function reducer(state = {}, action) {
  switch(action.type) {
  default:
    return state;
  }
}

export const getCollection = (store, id) => denormalize(id, Schema.collection, store.getState());

export function getCollectionBySlug(store, slug) {
  const collections = store.getState()[STATE_KEY];
  const found = _.find(_.values(collections), (collection) => collection.slug === slug);
  if (found) {
    return getCollection(store, found.id);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/collections.js